const initialstate = {
    toggle : false
}

export default initialstate